//King
import king1 from "../../assets/throwables/King/KingAnnoy.json";
import king2 from "../../assets/throwables/King/KingFrown.json";
import king3 from "../../assets/throwables/King/KingOnlyThrowingSword.json";
import king4 from "../../assets/throwables/King/KingPointingSword.json";
import king5 from "../../assets/throwables/King/KingSalute.json";
import king6 from "../../assets/throwables/King/KingSatisfactions.json";
import king7 from "../../assets/throwables/King/KingSkeptical.json";
import king8 from "../../assets/throwables/King/KingSurprise.json";
import king9 from "../../assets/throwables/King/KingTakingOffCrown.json";
import king10 from "../../assets/throwables/King/KingThrowingSword.json";
import king11 from "../../assets/throwables/King/KingWithMonocle.json";

//Jocker
import jocker1 from "../../assets/throwables/Joker/JokerAnxiety130.json";
import jocker2 from "../../assets/throwables/Joker/JokerConfuse130.json";
import jocker3 from "../../assets/throwables/Joker/JokerFrowning130.json";
import jocker4 from "../../assets/throwables/Joker/JokerMischievous130.json";
import jocker5 from "../../assets/throwables/Joker/JokerMocking130.json";
import jocker6 from "../../assets/throwables/Joker/JokerPullingJokerCard.json";
import jocker7 from "../../assets/throwables/Joker/JokerPunching130.json";
import jocker8 from "../../assets/throwables/Joker/JokerSkeptical130.json";
import jocker9 from "../../assets/throwables/Joker/JokerSurprise130.json";
import jocker10 from "../../assets/throwables/Joker/JokerThrowingEggs130.json";

//Queen
import queen1 from "../../assets/throwables/Queen/QueenBloingAKiss130.json";
import queen2 from "../../assets/throwables/Queen/QueenFrowning130.json";
import queen3 from "../../assets/throwables/Queen/QueenGiggling130.json";
import queen4 from "../../assets/throwables/Queen/QueenHandlingFlower130.json";
import queen5 from "../../assets/throwables/Queen/QueenLookingAtFingernails130.json";
import queen6 from "../../assets/throwables/Queen/QueenRollingEyes130.json";
import queen7 from "../../assets/throwables/Queen/QueenSkeptical130.json";
import queen8 from "../../assets/throwables/Queen/QueenSmirkingWithFan130.json";
import queen9 from "../../assets/throwables/Queen/QueenSurprise130.json";
import queen10 from "../../assets/throwables/Queen/QueenVeil130.json";
import { useDispatch, useSelector } from "react-redux";
import { handleSendEmojiToServer } from "@/Poker/redux/slices/gameTableSlice.js";

const throwables = [
  {
    id: "king1",
    emoji: king1,
    category: "King",
  },
  {
    id: "king2",
    emoji: king2,
    category: "King",
  },
  {
    id: "king3",
    emoji: king3,
    category: "King",
  },
  {
    id: "king4",
    emoji: king4,
    category: "King",
  },
  {
    id: "king5",
    emoji: king5,
    category: "King",
  },
  // {
  //   id: "king6",
  //   emoji: king6,
  //   category: "King",
  // },
  // {
  //   id: "king7",
  //   emoji: king7,
  //   category: "King",
  // },
  // {
  //   id: "king8",
  //   emoji: king8,
  //   category: "King",
  // },
  // {
  //   id: "king9",
  //   emoji: king9,
  //   category: "King",
  // },
  // {
  //   id: "king10",
  //   emoji: king10,
  //   category: "King",
  // },
  // {
  //   id: "king11",
  //   emoji: king11,
  //   category: "King",
  // },
  {
    id: "jocker1",
    emoji: jocker1,
    category: "Joker",
  },
  {
    id: "jocker2",
    emoji: jocker2,
    category: "Joker",
  },
  {
    id: "jocker3",
    emoji: jocker3,
    category: "Joker",
  },
  {
    id: "jocker4",
    emoji: jocker4,
    category: "Joker",
  },
  {
    id: "jocker5",
    emoji: jocker5,
    category: "Joker",
  },
  // {
  //   id: "jocker6",
  //   emoji: jocker6,
  //   category: "Joker",
  // },
  // {
  //   id: "jocker7",
  //   emoji: jocker7,
  //   category: "Joker",
  // },
  // {
  //   id: "jocker8",
  //   emoji: jocker8,
  //   category: "Joker",
  // },
  // {
  //   id: "jocker9",
  //   emoji: jocker9,
  //   category: "Joker",
  // },
  // {
  //   id: "jocker10",
  //   emoji: jocker10,
  //   category: "Joker",
  // },
  {
    id: "queen1",
    emoji: queen1,
    category: "Queen",
  },
  {
    id: "queen2",
    emoji: queen2,
    category: "Queen",
  },
  {
    id: "queen3",
    emoji: queen3,
    category: "Queen",
  },
  {
    id: "queen4",
    emoji: queen4,
    category: "Queen",
  },
  {
    id: "queen5",
    emoji: queen5,
    category: "Queen",
  },
  // {
  //   id: "queen6",
  //   emoji: queen6,
  //   category: "Queen",
  // },
  // {
  //   id: "queen7",
  //   emoji: queen7,
  //   category: "Queen",
  // },
  // {
  //   id: "queen8",
  //   emoji: queen8,
  //   category: "Queen",
  // },
  // {
  //   id: "queen9",
  //   emoji: queen9,
  //   category: "Queen",
  // },
  // {
  //   id: "queen10",
  //   emoji: queen10,
  //   category: "Queen",
  // },
];

export default function useGetThrowablesAndEmojis(tempTableId) {
  const dispatch = useDispatch();
  const getListOfAvailableThrowables = () => {
    return throwables;
  };

  const getThrowableEmojiById = (emojiId) => {
    const throwable = throwables.find((throwable) => throwable.id === emojiId);
    if (throwable) {
      return throwable.emoji;
    }
    return null;
  };

  const sendEmoji = (throwableId, playerName, tempTableId) => {
    dispatch(
      handleSendEmojiToServer({ emojiId: throwableId, tempTableId, playerName })
    );
  };

  return {
    getListOfAvailableThrowables,
    getThrowableEmojiById,
    sendEmoji,
  };
}
